import { DataBean } from "../DataBean";

export class WelfarePaymentConstants extends DataBean {


    public async getWelfarePaymentConstantsList(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getWelfarePaymentConstantsList_Number", [id]);
    }

    

 
}